import Fetcher from 'services/Fetcher'
import { API_DICTIONARY, HTTP_METHODS } from 'constants/api'
import { TUsersListRequest, TUsersListResponse } from './types'
import { ResponseWithPagination } from '../../../../../../../constants'
import { TDepartment } from '../../../types'

const fetcher = new Fetcher({})

export const getUsers = async (uuid, role, params) =>
  fetcher.request<TUsersListRequest, TUsersListResponse>({
    url: `${API_DICTIONARY.MY_COMMUNITY}${API_DICTIONARY.USERS}${
      API_DICTIONARY.HOSPITAL
    }${uuid}/${role ? role + '/' : ''}`,
    method: HTTP_METHODS.GET,
    params
  })

export const fetchDepartments = async (uuid, role) =>
  fetcher.request<unknown, ResponseWithPagination<TDepartment>>({
    url: `${API_DICTIONARY.MY_COMMUNITY}${API_DICTIONARY.USERS}${
      API_DICTIONARY.HOSPITAL
    }${uuid}/${role ? role + '/' : ''}${API_DICTIONARY.OPTIONS}${
      API_DICTIONARY.DEPARTMENTS
    }`,
    method: HTTP_METHODS.GET
  })
